export enum GenericTableSchemaFormat {
  ARRAY = "array",
  BOOLEAN = "boolean",
  INTEGER = "integer",
  FLOAT = "float",
  DECIMAL = "decimal",
  STRING = "string",
  DATE = "date",
  DATE_TIME = "date_time",
  LANGUAGE_RECORD = "language_record",
  JSON = "json",
}
